/* eslint-disable no-use-before-define */
import { gql } from "@apollo/client";

export const SET_ORDER_PAYMENT_TOKEN = gql`
  mutation setOrderPaymentToken($id: ID!) {
    setOrderPaymentToken(id: $id) {
      __typename
      ... on Order {
        id
        state
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`;
